import { BaseType } from '../../../base/base-type';
import { EmploymentStatusTypeId } from '../../enum/employment-status-type-id';

export class EmploymentStatusType extends BaseType {
  public declare id: EmploymentStatusTypeId;
}
